import BaseOptionsBundle from "%/dynamic-components/render-engine/classes/base-options";
import ImageShape from "%/dynamic-components/render-engine/options/image-options/image-shape";
import ObjectPosition from "%/dynamic-components/render-engine/options/image-options/object-position";
import FallbackImage from "%/dynamic-components/render-engine/options/image-options/fallback-image";
import ImageAltText from "%/dynamic-components/render-engine/options/image-options/image-alt-text";
import ImageFillBackground from "%/dynamic-components/render-engine/options/image-options/image-fill-background";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";
import Crop from "%/dynamic-components/render-engine/options/image-options/crop";
import Blur from "%/dynamic-components/render-engine/options/layout-options/blur";
import Brightness from "%/dynamic-components/render-engine/options/image-options/brightness";
import Contrast from "%/dynamic-components/render-engine/options/image-options/contrast";
import Grayscale from "%/dynamic-components/render-engine/options/image-options/grayscale";
import HueRotate from "%/dynamic-components/render-engine/options/image-options/hue-rotate";
import Invert from "%/dynamic-components/render-engine/options/image-options/invert";
import ImageOpacity from "%/dynamic-components/render-engine/options/image-options/opacity";
import Saturate from "%/dynamic-components/render-engine/options/image-options/saturate";
import Sepia from "%/dynamic-components/render-engine/options/image-options/sepia";
import BlendMode from "%/dynamic-components/render-engine/options/image-options/blend-mode";
import Rendering from "%/dynamic-components/render-engine/options/image-options/rendering";
import ClipPath from "%/dynamic-components/render-engine/options/image-options/clip-path";

export default class FallbackImageOptions extends BaseOptionsBundle {

  optionTitle = "Fallback Image";
  static optionClassName = "i-dynamic-image";
  inspectorToolGroup = "image";
  useInspectorLabel = false;
  static userInterfaceComponent = {
    component: inspectorTools.IMAGE_TOOLSET,
  };

  constructor(values = {}, hideFromInspector = {}) {
    super(values, [
      new FallbackImage(undefined, hideFromInspector["fallback-image"] ?? false),
      new ImageAltText(undefined, hideFromInspector["image-alt-text"] ?? false),
      new ImageShape(undefined, hideFromInspector["image-shape"] ?? false),
      new ObjectPosition(undefined, hideFromInspector["object-position"] ?? false),
      new ImageFillBackground(undefined, hideFromInspector["image-fill-background"] ?? false),
      new Crop(undefined, hideFromInspector["crop"] ?? false),

      // Effect Options
      Blur,
      Brightness,
      Contrast,
      Grayscale,
      HueRotate,
      Invert,
      ImageOpacity,
      Saturate,
      Sepia,
      BlendMode,
      Rendering,
      ClipPath,
    ]);
  }
}
